<template>
  <div class="bg-white p-3">
    <div class="mb-3">
      <b-input-group>
        <b-form-input
          class="search-bar"
          @keyup.enter="fetchData"
          placeholder="Search Name, Member ID, Tel., Email"
          v-model="filter.search"
        >
        </b-form-input>
        <b-input-group-append is-text class="mr-2">
          <b-iconstack font-scale="2" type="submit" @click="fetchData">
            <b-icon stacked icon="search" scale="0.5" variant="grey"></b-icon>
          </b-iconstack>
        </b-input-group-append>
        <b-button @click="showFilter()" class="btn button btn-mobile px-4">
          <font-awesome-icon
            icon="filter"
            title="filter-btn"
            class="main-color mr-0 mr-sm-1"
          />
          <span class="d-none d-sm-inline">Filter</span>
        </b-button>
        <b-dropdown
          text="Options"
          class="ml-2 main-color btn-filter"
          right
          :disabled="listEditOrder.length == 0"
        >
          <b-dropdown-item
            @click="confirmAction(1)"
            :disabled="
              isSelect.filter(
                (el) =>
                  el.status == 4 ||
                  el.status == 7 ||
                  el.status == 3 ||
                  el.status == 2 ||
                  el.status == 1 ||
                  el.status == 0 ||
                  el.pick_up_type == 1
              ).length > 0
            "
          >
            <span>รอจัดส่ง</span>
          </b-dropdown-item>

          <b-dropdown-item @click="confirmAction(2)" :disabled="true">
            <span> รอกรอกข้อมูล</span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="confirmAction(3)"
            :disabled="
              isSelect.filter(
                (el) =>
                  el.status == 4 ||
                  el.status == 7 ||
                  el.status == 2 ||
                  el.status == 3 ||
                  el.status == 1 ||
                  el.status == 0 ||
                  (el.status == 5 && el.pick_up_type == 2)
              ).length > 0
            "
          >
            <span>รับที่ร้านค้า</span>
          </b-dropdown-item>

          <b-dropdown-item @click="confirmAction(5)" :disabled="true">
            <span>กำลังจัดเตรียมสินค้า</span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="confirmAction(4)"
            :disabled="
              isSelect.filter(
                (el) =>
                  el.status == 2 ||
                  el.status == 5 ||
                  el.status == 4 ||
                  el.status == 0
              ).length > 0
            "
          >
            <span>สำเร็จ</span>
          </b-dropdown-item>
        </b-dropdown>
      </b-input-group>
    </div>

    <b-table
      :fields="fields"
      :items="data"
      :busy="isBusy"
      show-empty
      empty-text="No matching records found"
      responsive
    >
      <template v-slot:head(redeem_order_id)="">
        <b-form-group class="mb-0">
          <b-form-checkbox
            v-model="selectAllList"
            @change="selectAllTable"
            :unchecked-value="0"
            :value="1"
          ></b-form-checkbox>
        </b-form-group>
      </template>
      <template v-slot:cell(redeem_order_id)="data">
        <b-form-group class="mb-0">
          <!-- v-if="
            data.item.random_reward_item_type == 2 ||
            data.item.random_reward_item_type == 3
          " -->
          <b-form-checkbox
            v-model="listEditOrder"
            :value="data.item.mission_order_id"
            @change="handleSelect(data.item.mission_order_id, data.item)"
          ></b-form-checkbox>
        </b-form-group>
      </template>
      <template v-slot:cell(name)="data">
        <div>
          {{ data.item.name }}
          <span v-if="data.item.random_reward_item_type == 4">
            ({{ data.item.point }})</span
          >
        </div>
      </template>
      <template v-slot:cell(redeem_date)="data">
        <div>{{ data.item.redeem_date_string }}</div>
      </template>
      <template v-slot:cell(received_date)="data">
        <div v-if="data.item.status == 4">
          {{ data.item.received_date_string }}
        </div>
      </template>
      <template v-slot:cell(pick_up_type)="data">
        <div v-if="data.item.pick_up_type == 1">
          {{ data.item.branch_name || "-" }}
        </div>
        <div v-else-if="data.item.pick_up_type == 2">
          <p class="f-sm mb-0">
            <b>
              {{ data.item.name }}

              {{ convertTelePhone(data.item.telephone) }}
            </b>
            <br />
            <span v-if="data.item.home_address">
              {{ data.item.home_address }}
            </span>

            <span v-if="data.item.subdistrict">
              แขวง/ตำบล {{ data.item.subdistrict }}
            </span>
            <span v-if="data.item.district">
              เขต/อำเภอ {{ data.item.district }}
            </span>
            <span v-if="data.item.province"> {{ data.item.province }}</span>
            <span v-if="data.item.zip_code"> {{ data.item.zip_code }}</span>
          </p>
        </div>
        <div>({{ textPickup(data.item.pick_up_type) }})</div>
      </template>
      <template v-slot:cell(status_name)="data">
        <div :class="textStatus(data.item.status, 2)">
          {{ textStatus(data.item.status, 1) }}
        </div>
      </template>
      <template v-slot:cell(order_note)="data">
        <font-awesome-icon
          icon="sticky-note"
          class="pointer"
          @click="getNote(data.item)"
        />
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
    </b-table>

    <Pagination
      @handleChangeTake="handleChangeTake"
      @pagination="pagination"
      :filter="filter"
      :rows="rows"
      take="length"
      page="start"
    />

    <SideBarFilter
      ref="sidebarFilter"
      :filter="filter"
      :hideStatusFilter="false"
      :placeholder="'Search Name'"
      @searchAll="submitFilter"
      @clearFilter="clearFilter"
      :hideSearchBar="true"
    >
      <template v-slot:filter-option>
        <b-form-group>
          <template #label>
            <div class="mb-2 main-label"><b>Order Status</b></div>

            <b-form-checkbox
              v-model="selectAll"
              aria-describedby="Status"
              aria-controls="Status"
              @change="StatusToggleAll"
            >
              Select All
            </b-form-checkbox>
          </template>

          <template v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              class="ml-4"
              id="checkbox-group-2"
              stacked
              v-model="filter.random_reward_order_status"
              :aria-describedby="ariaDescribedby"
              @change="clearSelectAll"
            >
              <b-form-checkbox :value="1" id="waiting"
                >รอจัดส่ง</b-form-checkbox
              >
              <b-form-checkbox :value="2" id="waiting-address"
                >รอกรอกข้อมูล
              </b-form-checkbox>
              <b-form-checkbox :value="3" id="pickup-branch"
                >รับที่ร้านค้า
              </b-form-checkbox>
              <b-form-checkbox :value="4" id="success">สำเร็จ</b-form-checkbox>
              <b-form-checkbox :value="5" id="prepare"
                >กำลังจัดเตรียมสินค้า
              </b-form-checkbox>
              <b-form-checkbox :value="7" id="prepare">
                รับของโดยไม่ได้รับ OTP
              </b-form-checkbox>
            </b-form-checkbox-group>
          </template>
        </b-form-group>
        <b-form-group>
          <template #label>
            <div class="mb-2 main-label"><b>Pick up Type</b></div>

            <b-form-checkbox
              v-model="pickupAll"
              aria-describedby="Status"
              aria-controls="Status"
              @change="pickupToggleAll"
            >
              Select All
            </b-form-checkbox>
          </template>

          <template v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              class="ml-4"
              id="pickup-group"
              stacked
              v-model="filter.pick_up_type"
              :aria-describedby="ariaDescribedby"
              @change="clearPickupAll"
            >
              <b-form-checkbox :value="1" id="pick-up-branch">
                Pick up at branch
              </b-form-checkbox>
              <b-form-checkbox :value="2" id="pick-up-home">
                Pick up at home
              </b-form-checkbox>
              <b-form-checkbox :value="3" id="pick-up-home">
                None
              </b-form-checkbox>
            </b-form-checkbox-group>
          </template>
        </b-form-group>
        <b-form-group>
          <template #label>
            <div class="mb-2 main-label"><b>Product Type</b></div>
            <b-form-checkbox
              v-model="productTypeAll"
              aria-describedby="Status"
              aria-controls="Status"
              @change="productTypeToggle"
            >
              Select All
            </b-form-checkbox>
          </template>

          <template v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              class="ml-4"
              id="pickup-group"
              stacked
              v-model="filter.product_type"
              :aria-describedby="ariaDescribedby"
              @change="clearProductAll"
            >
              <b-form-checkbox :value="1" id="product">
                Product
              </b-form-checkbox>
              <b-form-checkbox :value="2" id="coupon"> Coupon </b-form-checkbox>
              <b-form-checkbox :value="3" id="point"> Point </b-form-checkbox>
            </b-form-checkbox-group>
          </template>
        </b-form-group>
      </template>
    </SideBarFilter>
    <b-modal
      ref="modalUpdateNote"
      centered
      body-class="p-4"
      v-model="isShowModal"
    >
      <template #modal-header>
        <div class="ft-black">Additional Notes</div>
      </template>
      <div>
        <InputTextArea
          :rows="4"
          textFloat="Additional Notes (If Any)"
          placeholder="Additional Notes"
          id="note"
          v-model="filterNote.note"
        />
      </div>
      <template #modal-footer>
        <b-row>
          <b-col
            ><b-button @click="isShowModal = false" class="btn-cancel">
              Cancel
            </b-button></b-col
          >
          <b-col
            ><b-button class="btn-confirm" @click.prevent="updateNote">
              Save
            </b-button></b-col
          >
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ModalUpdateNote from "@/components/redeem/modal/ModalUpdateNote";
export default {
  props: ["form", "tabIndex"],
  components: {
    ModalUpdateNote,
  },
  data() {
    return {
      isFetch: false,
      isBusy: false,
      isShowModal: false,
      statColumn: [
        {
          name: "All Redeem",
          key: "count_Redeemed",
          isPercent: false,
          isDecimal: false,
        },

        {
          name: "In Progress",
          key: "in_Progress",
          isPercent: false,
          isDecimal: false,
        },
        {
          name: "Success",
          key: "success",
          isPercent: false,
          isDecimal: false,
        },
        {
          name: "No Reward",
          key: "no_Reward",
          isPercent: false,
          isDecimal: false,
        },
      ],
      data: {},
      rows: 0,
      filter: {
        redeemId: parseInt(this.$route.params.id),
        page: 1,
        length: 10,
        start: 1,
        search: "",
        branchId: 0,
        redeemOrderStatus: 0,

        pick_up_type: [1, 2, 3],
        product_type: [1, 2, 3],
        random_reward_order_status: [1, 2, 3, 4, 5, 7],
        PageNumber: 1,
      },
      fields: [
        {
          key: "redeem_order_id",
          label: "",
          thClass: "text-nowrap",
        },
        {
          key: "name",
          label: "Name-Surname",
          thClass: "text-nowrap",
        },
        {
          key: "member_id",
          label: "Member ID",
          thClass: "text-nowrap",
        },
        {
          key: "telephone",
          label: "Tel.",
          thClass: "text-nowrap",
        },
        {
          key: "email",
          label: "Email",
          thClass: "text-nowrap",
        },

        {
          key: "redeem_date",
          label: "Redeem Date",
          thClass: "text-nowrap",
        },
        {
          key: "gift",
          label: "Gift",
          thClass: "text-nowrap",
        },
        {
          key: "pick_up_type",
          label: "Pick Up",
          thClass: "text-nowrap",
        },
        {
          key: "status_name",
          label: "Status",
          thClass: "text-nowrap",
        },
        {
          key: "received_date",
          label: "Date/Time Received",
          thClass: "text-nowrap",
        },
        {
          key: "order_note",
          label: "Note",
          thClass: "text-nowrap",
        },
      ],
      isLoading: true,
      listEditOrder: [],
      ListIdAll: [],
      selectAllList: 0,
      selectAll: true,
      pickupAll: true,
      productTypeAll: true,
      actionDisabled: [],
      isSelect: [],
      filterNote: {
        id: 0,
        note: null,
      },
    };
  },
  watch: {
    tabIndex(val) {
      if (val == 4) {
        if (!this.isFetch) {
          this.getData();
          this.isFetch = true;
        }
      }
    },
  },
  created() {},
  methods: {
    textPickup(id) {
      switch (id) {
        case 1:
          return "Pick up at branch";
        case 2:
          return "Pick up at home";

        default:
          return "None";
      }
    },
    textStatus(id, mode) {
      if (mode == 1) {
        switch (id) {
          case 1:
            return "รอจัดส่ง";
          case 2:
            return "รอกรอกข้อมูล";
          case 3:
            return "รับที่ร้านค้า";
          case 4:
            return "สำเร็จ";
          case 5:
            return "กำลังจัดเตรียมสินค้า";
          case 7:
            return "รับของโดยไม่ได้รับ OTP";
          default:
            return "-";
        }
      }
      if (mode == 2) {
        switch (id) {
          case 1:
            return "text-primary";
          case 2:
            return "text-warning";
          case 3:
            return "text-primary";
          case 4:
            return "text-success";
          case 5:
            return "text-info";
          case 7:
            return "text-primary";
          default:
            return "-";
        }
      }
    },
    async getData() {
      this.isBusy = true;
      const resp = await this.axios.post("/mission/statusdetail", this.filter);

      this.selectAllList = 0;
      this.ListIdAll = resp.data.detail.data.redeemList.map(
        (el) => el.mission_order_id
      );
      this.isSelect = [];
      this.data = resp.data.detail.data.redeemList;
      this.rows = resp.data.detail.redeemListTotal;
      this.isBusy = false;
      // this.isLoading = false;
      this.$emit("emitActive", resp.data.detail.redeemListTotal);
    },
    async fetchData() {
      this.isBusy = true;
      const resp = await this.axios.post("/mission/statusdetail", this.filter);

      this.ListIdAll = resp.data.detail.data.redeemList.map(
        (el) => el.mission_order_id
      );
      if (this.selectAllList) {
        this.isSelect = resp.data.detail.data.redeemList;
        this.listEditOrder = resp.data.detail.data.redeemList.map(
          (el) => el.mission_order_id
        );
      } else {
        this.isSelect = this.isSelect.filter((el) =>
          resp.data.detail.data.redeemList.find(
            (e) => e.mission_order_id == el.mission_order_id
          )
        );
        this.listEditOrder = this.isSelect
          .filter((el) =>
            resp.data.detail.data.redeemList.find(
              (e) => e.mission_order_id == el.mission_order_id
            )
          )
          .map((el) => el.id);
      }
      this.data = resp.data.detail.data.redeemList;
      this.rows = resp.data.detail.redeemListTotal;
      this.isBusy = false;
      this.$emit("emitActive", resp.data.detail.redeemListTotal);
    },
    handleChangeTake(value) {
      this.filter.start = 1;

      this.fetchData();
    },
    pagination(val) {
      this.filter.start = val;

      this.fetchData();
    },
    handleSelect(val, items) {
      if (this.isSelect.find((el) => el.mission_order_id == val))
        this.isSelect.splice(
          this.isSelect.findIndex((el) => el.mission_order_id == val),
          1
        );
      else this.isSelect.push(items);

      this.selectAllList =
        this.ListIdAll.length == this.isSelect.length ? 1 : 0;
    },

    async exportData() {
      const res = await this.axios.post(
        `/RandomReward/export_order`,
        {
          is_all: this.listEditOrder.length > 0 ? 0 : 1, // if 0 == not all, if 1 == all
          random_reward_id: this.$route.params.id,
          random_reward_order_id: this.listEditOrder, // list int
          pick_up_type: this.filter.pick_up_type,
          random_reward_order_status: this.filter.random_reward_order_status,
          product_type: this.filter.product_type,
        },

        {
          responseType: "blob",
        }
      );
      let data = res;

      var fileURL = window.URL.createObjectURL(new Blob([data.data]));
      var fileLink = document.createElement("a");
      // var dateExcel = this.$moment().format("DDMMYYYYhhmmss");
      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `random-reward-${this.form.name}-report.xlsx`
      );
      document.body.appendChild(fileLink);
      fileLink.click();
      this.$bus.$emit("hideLoading");
    },
    async confirmAction(status) {
      let payload = {
        id: this.listEditOrder, // list random_reward_order_id
        random_reward_order_status: status,
      };
      this.$bus.$emit("showLoading");
      const resp = await this.axios.post("mission/edit_order_status", payload);
      this.$bus.$emit("hideLoading");
      if (resp.data.result) this.getData(), (this.listEditOrder = []);
      else this.errorAlert(resp.data.message);
    },
    selectAllTable(value) {
      if (value) {
        this.isSelect = JSON.parse(JSON.stringify(this.data));
        this.listEditOrder = this.ListIdAll;
      } else {
        this.listEditOrder = [];
        this.isSelect = [];
      }
    },
    clearFilter() {
      this.filter = {
        redeemId: this.$route.params.id,
        length: 10,
        start: 1,
        search: "",
        branchId: 0,
        pick_up_type: [1, 2],
        product_type: [1, 2, 3],
        random_reward_order_status: [1, 2, 3, 4, 5, 7],
      };
      this.productTypeAll = true;
      this.selectAll = true;
      this.pickupAll = true;
    },

    showFilter() {
      this.$refs.sidebarFilter.show();
    },
    StatusToggleAll(checked) {
      this.filter.random_reward_order_status = checked
        ? [1, 2, 3, 4, 5, 7]
        : [];
    },
    pickupToggleAll(checked) {
      this.filter.pick_up_type = checked ? [1, 2] : [];
    },
    productTypeToggle(checked) {
      this.filter.product_type = checked ? [1, 2, 3] : [];
    },
    clearSelectAll() {
      this.selectAll =
        this.filter.random_reward_order_status.length == 6 ? true : false;
    },
    clearPickupAll() {
      this.pickupAll = this.filter.pick_up_type.length == 2 ? true : false;
    },
    clearProductAll() {
      this.productTypeAll = this.filter.product_type.length == 3 ? true : false;
    },
    submitFilter() {
      this.filter.PageNumber = 1;
      this.filter.page = 1;
      this.fetchData();
    },
    async getNote(item) {
      this.filterNote.note = item.order_note;
      this.filterNote.id = item.mission_order_id;

      this.isShowModal = true;
    },
    async updateNote(val) {
      const data = await this.axios.post(
        "/mission/edit_order_note",
        this.filterNote
      );
      if (data.data.result === 1) {
        this.successAlert();
        this.fetchData();
        this.$nextTick().then(() => {
          this.isShowModal = false;
        });
      } else {
        this.errorAlert(data.data.message);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .dropdown-item.disabled {
  background: whitesmoke;
}
::v-deep .dropdown-item:hover:not(.disabled) {
  background-color: var(--primary-color);
  color: var(--font-primary-color) !important;
}
::v-deep .dropdown-menu {
  overflow: hidden;
  padding: 0;
}
</style>
